module.exports = __webpack_public_path__ + "img/24.133b50c2.jpg";